import CourseSelector from './course-selector.vue';

export default {
  install(application) {
    application.component('yx-course-selector', CourseSelector);
  },
};
